import React, {useState} from 'react'
import Navbar from '../components/consoleFaq/Navbar'
import Sidebar from '../components/Console/Sidebar'
import 'bootstrap/dist/css/bootstrap.min.css';
import ConsoleFooter from '../components/Console/Footer'
import Content from '../components/consoleFaq/content'
const ConsoleFaq = () => {
  const [isOpen, setIsOpen] = useState(false)

	const toggle = () => {
		setIsOpen(!isOpen)
	}
  return (
    <>
      <Sidebar isOpen= {isOpen} toggle={toggle}/>
		  <Navbar toggle={toggle} />
      <Content/>
      <ConsoleFooter />
    </>
  )
}

export default ConsoleFaq
